module.exports = __webpack_public_path__ + "static/media/recommended2.cd03f8d1.png";